(function() {
    'use strict';
    
a3_cabin_reports.factory('FlightServiceEventsFactory', FlightServiceEventsFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name FlightServiceEventsFactory
    * @description 
    * Get selected flight info
    * @ngInject
    */ 
function FlightServiceEventsFactory($http, apiUrl, GenericService) {
    
    var service = {
        setEventTypes: setEventTypes,
        setEventsForFlightId: setEventsForFlightId,
        getEventsFromLS: getEventsFromLS,
        getEventTypes: getEventTypes,
        getEventsByFlightIdFromLS: getEventsByFlightIdFromLS,
        getEvents: getEvents,
        saveEvent: saveEvent,
        cleanOldDataServiceEvents: cleanOldDataServiceEvents,
        upsertEvents: upsertEvents
    };

    /**
    * Initialize the EventType 
    * @memberof FlightServiceEventsFactory
    */
    function EventType() {
        this.Id = null;
        this.Code = null;
        this.Title = null;
        this.Description = null;
        this.EnableStartTime = true;
        this.EnableEndTime = false;
        this.EnableNotRequired = false;
        this.AllowRemarks = false;
    }
    var objEventType = 'flightEventTypes';
    var objEventTypeCallback = EventType;

    /**
     * Save Event Types
     * @memberof FlightServiceEventsFactory
     * @param {Array} EventTypes
     */
    function setEventTypes(eventTypes) {
        GenericService.saveAll(eventTypes, objEventType);
    }

    /**
     * Get Event Types
     * @memberof FlightServiceEventsFactory
     * @returns {Array} EventTypes 
     */
    function getEventTypes() {
        return GenericService.list(objEventType, objEventTypeCallback);
    }


    /**
    * Initialize the Event 
    * @memberof FlightServiceEventsFactory
    */
    function Event() {
        this.FlightId = null;
        this.EventTypeId = null;
        this.EventCode = null;
        this.StartTime = null;
        this.EndTime = null;
        this.NotRequired = null;
        this.Remarks = null;
        this.LastUpdated = null;
    }
    var objEvent = 'flightEvents';
    var objEventCallback = Event;


    function getEventsFromLS() {
        return GenericService.list(objEvent, objEventCallback);
    }

    function getEventsByFlightIdFromLS(flightId) {
        var storedEvents = getEventsFromLS();  
        return  storedEvents.filter(x => x.FlightId == flightId);
    }

    function upsertEvents(events) {
        var flightIds = events.map(x => x.FlightId);
        var storedEvents = getEventsFromLS();  
        var otherEvents = storedEvents.filter(x => !flightIds.includes(x.FlightId));
        var mergeEvents = otherEvents.concat(events);
        setEvents(mergeEvents);
    }

    function setEventsForFlightId(flightId, events) {
        var storedEvents = getEventsFromLS();  
        var filterEvents = storedEvents.filter(x => x.FlightId != flightId);
        var mergeEvents = filterEvents.concat(events);
        setEvents(mergeEvents);
    }

    function setEvents(events) {
        GenericService.saveAll(events, objEvent);
    }

    function getEvents(flightId, callback){
         var uri = encodeURI(apiUrl + '/FlightServiceEvents/GetEvents?flightId=' + flightId);
        return $http.get(uri, { 'Content-Type': 'application/json' })
        .catch(callback); 
    }

    function saveEvent (event, callback){
        var eventTimesFixed = { ...event };
        if(event.StartTime){
            eventTimesFixed.StartTime = event.StartTime.clone();
            var startDateObj = new Date(eventTimesFixed.StartTime).fromUTC();
            eventTimesFixed.StartTime = moment(startDateObj);
        }else{
            eventTimesFixed.StartTime = null;
        }
        if(event.EndTime){
            eventTimesFixed.EndTime = event.EndTime.clone();
            var endDateObj = new Date(eventTimesFixed.EndTime).fromUTC();
            eventTimesFixed.EndTime = moment(endDateObj);
        }else{
            eventTimesFixed.EndTime = null;
        }

        return $http.post(apiUrl + '/FlightServiceEvents/SaveEvent', eventTimesFixed, { 'Content-Type': 'application/json' })
        .catch(callback); 
    }

    function cleanOldDataServiceEvents(responseFlightIds){    
        var storedEvents = getEventsFromLS();  
        var previousEvents = storedEvents.filter(x => responseFlightIds.includes(x.FlightId));
        setEvents(previousEvents);
    }

    return service;
}
})();